const routes = [
  {
    path: '/index',
    name: 'Index',
    component: () => import('../../views/Index/index.vue'),
    meta: {
      auth: false,
      titleKey: 'nav.home',
      icon: 'home',
      selectIcon: 'home-activate',
      keepAlive: true,
      headerTheme: 'dark',
      showTips: true,
      isMeun: true,
      title: '首页'
    }
  },
  {
    path: '/notice',
    name: 'NoticeDetail',
    component: () => import('../../views/notice/index.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      headerTheme: 'dark',
      showTips: false,
      hideTabBar: true,
      title: '平台公告'
    }
  },
  {
    path: '/nft',
    name: 'Nft',
    component: () => import('../../views/nft/index.vue'),
    meta: {
      auth: false,
      titleKey: 'nav.home',
      icon: 'nft',
      selectIcon: 'nft-activate',
      // hideNav: true,
      // hideTabBar: true,
      keepAlive: true,
      headerTheme: 'dark',
      showTips: true,
      isMeun: true,
      title: 'NFT'
    }
  },
  {
    path: '/asstes',
    name: 'Asstes',
    component: () => import('../../views/asstes/index.vue'),
    meta: {
      auth: false,
      titleKey: 'nav.home',
      icon: 'asstes',
      selectIcon: 'asstes-activate',
      keepAlive: true,
      headerTheme: 'dark',
      showTips: true,
      isMeun: true,
      // hideNav: true,
      // hideTabBar: true,
      title: ' 资产'
    }
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('../../views/withdraw/index.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      headerTheme: 'dark',
      showTips: false,
      hideTabBar: true,
      title: '提币'
    }
  },
  {
    path: '/withdraw/record',
    name: 'WithdrawRecord',
    component: () => import('../../views/withdraw/record.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      headerTheme: 'dark',
      showTips: false,
      hideTabBar: true,
      title: '提现记录'
    }
  },
  {
    path: '/team',
    name: 'Team',
    component: () => import('../../views/Team/index.vue'),
    meta: {
      auth: false,
      titleKey: 'nav.home',
      icon: 'team',
      selectIcon: 'team-activate',
      keepAlive: true,
      headerTheme: 'dark',
      showTips: true,
      isMeun: true,
      title: '团队'
    }
  },
  {
    path: '/team/reward',
    name: 'TeamReward',
    component: () => import('../../views/team-reward/index.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      headerTheme: 'dark',
      showTips: false,
      hideTabBar: true,
      title: '团队奖励明细'
    }
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('../../views/partner/index.vue'),
    meta: {
      auth: false,
      titleKey: 'nav.home',
      icon: 'partner',
      selectIcon: 'partner-activate',
      keepAlive: true,
      headerTheme: 'dark',
      showTips: true,
      isMeun: true,
      title: '合伙人'
    }
  },
]
export default routes
